import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/layout/AppLayout";
import Dashboard from "@/pages/Dashboard";
import FreelanceFinder from "@/pages/FreelanceFinder";
import LeadEngine from "@/pages/LeadEngine";
import RFPIntel from "@/pages/RFPIntel";
import SocialAutomation from "@/pages/SocialAutomation";
import WebsiteIntel from "@/pages/WebsiteIntel";
import EmailIntel from "@/pages/EmailIntel";
import MeetingIntel from "@/pages/MeetingIntel";
import CRM from "@/pages/CRM";
import Settings from "@/pages/Settings";
import Login from "./pages/Login";
import ProtectedRoute from "./components/common/ProtectedRoute";

import AnalyzerLayout from "@/pages/analyzer/AnalyzerLayout";
import AnalyzerDashboard from "@/pages/analyzer/pages/Dashboard";
import CompanyAnalysis from "@/pages/analyzer/pages/CompanyAnalysis";
import AnalysisProgress from "@/pages/analyzer/pages/AnalysisProgress";
import AnalysisHistory from "@/pages/analyzer/pages/AnalysisHistory";
import SolutionsCatalog from "@/pages/analyzer/pages/SolutionsCatalog";
import BusinessIntelligence from "@/pages/analyzer/pages/BusinessIntelligence";
import EvidencePage from "@/pages/analyzer/pages/Evidence";
import ProposalCenter from "@/pages/analyzer/pages/ProposalCenter";
import ClientPortal from "@/pages/analyzer/pages/ClientPortal";
import AIConsultant from "@/pages/analyzer/pages/AIConsultant";
import ReviewGapAnalysis from "@/pages/analyzer/pages/ReviewGapAnalysis";
import InstagramAnalysis from "@/pages/analyzer/pages/InstagramAnalysis";
import LinkedInAnalysis from "@/pages/analyzer/pages/LinkedInAnalysis";
import RedditAnalysis from "@/pages/analyzer/pages/RedditAnalysis";
import GlassdoorAnalysis from "@/pages/analyzer/pages/GlassdoorAnalysis";
import G2Analysis from "@/pages/analyzer/pages/G2Analysis";
import TrustpilotAnalysis from "@/pages/analyzer/pages/TrustpilotAnalysis";
import TwitterAnalysis from "@/pages/analyzer/pages/TwitterAnalysis";

import LeadFinderLayout from "@/pages/lead-finder/LeadFinderLayout";
import LeadFinderDashboard from "@/pages/lead-finder/pages/Dashboard";
import MapScanner from "@/pages/lead-finder/pages/MapScanner";
import LeadsList from "@/pages/lead-finder/pages/LeadsList";
import CRMPipeline from "@/pages/lead-finder/pages/CRMPipeline";
import LeadFinderSettings from "@/pages/lead-finder/pages/Settings";
import Base2brandLeads from "./components/common/Base2brandLeads";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="/freelance" element={<FreelanceFinder />} />
              <Route path="/leads" element={<LeadEngine />} />
              <Route path="/rfp" element={<RFPIntel />} />
              <Route path="/lead-finder" element={<LeadFinderLayout />}>
                <Route index element={<LeadFinderDashboard />} />
                <Route path="scanner" element={<MapScanner />} />
                <Route path="leads" element={<LeadsList />} />
                <Route path="crm" element={<CRMPipeline />} />
                <Route path="settings" element={<LeadFinderSettings />} />
              </Route>
              <Route path="/social" element={<SocialAutomation />} />
              <Route path="/website" element={<Base2brandLeads />} />
              <Route path="/email" element={<EmailIntel />} />
              <Route path="/meetings" element={<MeetingIntel />} />
              <Route path="/analyzer" element={<AnalyzerLayout />}>
                <Route index element={<AnalyzerDashboard />} />
                <Route path="analysis/new" element={<CompanyAnalysis />} />
                <Route path="analysis/:id/progress" element={<AnalysisProgress />} />
                <Route path="analysis/:id/evidence" element={<EvidencePage />} />
                <Route path="analysis/:id/intelligence" element={<BusinessIntelligence />} />
                <Route path="analysis/:id/proposal" element={<ProposalCenter />} />
                <Route path="analysis/:id/consultant" element={<AIConsultant />} />
                <Route path="analysis/:id/portal" element={<ClientPortal />} />
                <Route path="history" element={<AnalysisHistory />} />
                <Route path="solutions" element={<SolutionsCatalog />} />
                <Route path="gap-analysis" element={<ReviewGapAnalysis />} />
                <Route path="instagram-analysis" element={<InstagramAnalysis />} />
                <Route path="linkedin-analysis" element={<LinkedInAnalysis />} />
                <Route path="reddit-analysis" element={<RedditAnalysis />} />
                <Route path="glassdoor-analysis" element={<GlassdoorAnalysis />} />
                <Route path="g2-analysis" element={<G2Analysis />} />
                <Route path="trustpilot-analysis" element={<TrustpilotAnalysis />} />
                <Route path="twitter-analysis" element={<TwitterAnalysis />} />
              </Route>
              <Route path="/crm" element={<CRM />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" richColors position="bottom-right" />
    </div>
  );
}

export default App;
